module.exports = __webpack_public_path__ + "img/administrator.f4a4f8e6.svg";